module.exports = new __parcel__URL__("AsanaSelectBoardIllustrationSpork.2bbab650.svg").toString();